'use client'

interface BlogCardProps {
  id: string
  title: string
  image: string
  date: string
  category: string
  likes: number
  comments: number
}

export default function BlogCard({ id, title, image, date, likes, comments }: BlogCardProps) {
  return (
    <div
      className="overflow-hidden"
      style={{
        border: '1px solid rgba(30,55,140,0.65)',
        borderRadius: '8px',
        background: 'rgba(10,15,35,0.6)',
      }}
    >
      {/* Image */}
      <div style={{ height: '150px', overflow: 'hidden' }}>
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content */}
      <div className="p-4">
        <h3
          className="font-bold text-white mb-3 leading-snug"
          style={{ fontSize: '13px' }}
        >{title}</h3>

        {/* Date + likes + comments row */}
        <div
          className="flex items-center justify-between pt-3"
          style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
        >
          <div className="flex items-center gap-1" style={{ color: 'rgba(249,115,22,0.9)' }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            <span style={{ fontSize: '10px' }}>{date}</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1" style={{ color: 'rgba(255,255,255,0.45)', fontSize: '10px' }}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
              <span>{likes}</span>
            </div>
            <div className="flex items-center gap-1" style={{ color: 'rgba(255,255,255,0.45)', fontSize: '10px' }}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
              <span>{comments}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
